// ContactCTA.jsx
import { motion } from 'framer-motion';
import { FaPhoneAlt, FaArrowRight } from 'react-icons/fa';
import { IMG, COMPANY } from '../../data/siteData';
import { useQuoteModal } from '../../context/QuoteModalContext';
import './ContactCTA.css';
import { Link } from 'react-router-dom';

export default function ContactCTA() {
  const { openQuote } = useQuoteModal();
  return (
    <section className="contact-cta" style={{ backgroundImage: `url(${IMG.aerialSand})` }}>
      <div className="contact-cta__overlay" />
      <div className="container contact-cta__content">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7 }}
        >
          <p className="eyebrow">Ready To Ship?</p>
          <h2 className="section-title">Let's Move Your<br />Next Consignment.</h2>
          <p className="contact-cta__text">
            Tell us what needs to move and where — our dispatch team responds within minutes.
          </p>
          <div className="contact-cta__actions">
            <Link className="btn btn-primary" to="/contact">
              Request A Quote <FaArrowRight />
            </Link>
            <a href={`tel:${COMPANY.phoneHref}`} className="btn btn-outline-light">
              <FaPhoneAlt /> {COMPANY.phone}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}